class Sequense {
  constructor (el) {
    this.el = el
    this.canvas = this.el.querySelector('canvas')
    this.canvas.width = 1000
    this.canvas.height = 1000
    this.context = this.canvas.getContext("2d")
    this.baseUrl = this.el.getAttribute('data-url')
    this.frames = parseInt(this.el.getAttribute('data-frames'))
    this.currentFrame = 0
    this.images = []

    this.speed = 1000/30
    this.timeout = null
    this.reqId = null

    return this.initDefaults()
  }

  initDefaults () {
    console.log('sequense init')
    console.log('sequense base url: ' + this.baseUrl)
    console.log('sequense total frames: ' + this.frames)

    this.getImages()
  }

  getCurrentFrame (index) {
    return `${this.baseUrl + index.toString().padStart(3, '0')}.png`
  }

  getImages () {
    for (let i = 0; i < this.frames; i++) {
      const img = new Image();
      img.src = this.getCurrentFrame(i);
      this.images.push(img);
    }

    this.images[this.frames - 1].addEventListener('load', () => {
      this.render()
      this.el.classList.add('active')
      setTimeout(() => {
        this.reqId = window.requestAnimationFrame(() => this.autoplay());
      }, 0)
    })
  }

  autoplay () {
    this.timeout = setTimeout(() => {
      if (this.currentFrame === this.frames) {
        this.currentFrame = 0
        this.render()
      } else {
        this.render()
        this.currentFrame++
      }
      this.reqId = window.requestAnimationFrame(() => this.autoplay())
    }, this.speed)
  }

  render () {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.context.drawImage(this.images[this.currentFrame], 0, 0, 1000, 1000)
  }
}

window.addEventListener('load', () => {
  const el = document.querySelector('#sequense')

  if (el) {
    new Sequense(el)
  }
})